import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

function TermsConditions() {
  const navigate = useNavigate();

  return (
    <div className="page" style={{ maxWidth: '900px', margin: '0 auto', padding: '2rem 1rem' }}>
      <button onClick={() => navigate('/')} className="btn btn-ghost" style={{ marginBottom: '2rem' }}>
        <ArrowLeft size={20} style={{ marginRight: '0.5rem' }} /> Back to Home
      </button>

      <h1 style={{ fontSize: '2.5rem', marginBottom: '2rem' }}>Terms & Conditions</h1>
      
      <div style={{ fontSize: '1rem', lineHeight: 1.8, color: '#D1D5DB' }}>
        <p style={{ marginBottom: '1.5rem' }}><strong>Last Updated:</strong> January 2025</p>
        
        <h2 style={{ fontSize: '1.75rem', marginTop: '2rem', marginBottom: '1rem' }}>1. Acceptance of Terms</h2>
        <p style={{ marginBottom: '1rem' }}>By accessing and using Astrowins, you accept and agree to be bound by these Terms and Conditions.</p>

        <h2 style={{ fontSize: '1.75rem', marginTop: '2rem', marginBottom: '1rem' }}>2. Service Description</h2>
        <p style={{ marginBottom: '1rem' }}>Astrowins provides:</p>
        <ul style={{ marginBottom: '1.5rem', paddingLeft: '2rem' }}>
          <li>Numerology analysis based on Chaldean system and Lo Shu Grid</li>
          <li>Vastu Shastra consultation for residential and commercial spaces</li>
          <li>Vedic Astrology readings including Kundali, Dasha, and predictions</li>
          <li>AI-powered insights and personalized recommendations</li>
        </ul>

        <h2 style={{ fontSize: '1.75rem', marginTop: '2rem', marginBottom: '1rem' }}>3. User Obligations</h2>
        <ul style={{ marginBottom: '1.5rem', paddingLeft: '2rem' }}>
          <li>Provide accurate birth details for correct analysis</li>
          <li>Use services for personal guidance only</li>
          <li>Not share your account with others</li>
          <li>Profile can be edited maximum 3 times to prevent misuse</li>
        </ul>

        <h2 style={{ fontSize: '1.75rem', marginTop: '2rem', marginBottom: '1rem' }}>4. Intellectual Property</h2>
        <p style={{ marginBottom: '1rem' }}>All content, algorithms, and analysis reports are proprietary to Astrowins and protected by copyright laws.</p>

        <h2 style={{ fontSize: '1.75rem', marginTop: '2rem', marginBottom: '1rem' }}>5. Limitation of Liability</h2>
        <p style={{ marginBottom: '1rem' }}>Astrological predictions and numerology analyses are for guidance purposes only. We are not liable for decisions made based on our services.</p>

        <h2 style={{ fontSize: '1.75rem', marginTop: '2rem', marginBottom: '1rem' }}>6. Contact</h2>
        <p>For questions about these terms, contact: <a href="mailto:hello@astrowins.in" style={{ color: '#00D9FF' }}>hello@astrowins.in</a></p>
      </div>
    </div>
  );
}

export default TermsConditions;